import { buildNavigationType } from "../shared/buildNavigationType";
import { buildPageObject } from "../shared/buildPageObject";
import { EventAction, EventName } from "../types";

import type { PageViewEvent, PageViewInput } from "./types";

type EventBuilder = (input?: PageViewInput) => PageViewEvent;

const pageViewEventBuilder: EventBuilder = (input) => {
  const { customProperties, currentPath } = input || {};

  const timestamp = new Date(Date.now() - 1).toISOString();

  const pageObject = buildPageObject(currentPath);
  const navigationType = buildNavigationType();

  return {
    name: EventName.PageView,
    action: EventAction.View,
    target: pageObject,
    navigationType,
    timestamp,
    customProperties,
  };
};

export { pageViewEventBuilder };
